<template>
  <b-modal @click.self="onCancel" v-model="isModalActive" :can-cancel="false">
    <div class="modal_card">
      <h1 class="modal_title">
        VIEW BLOG
        <span @click="onCancel">Close</span>
      </h1>
      <div class="modal_body">
        <div class="modal_crd">
          <h1>Title</h1>
          <p>{{ value.title }}</p>
        </div>
        <div class="modal_crd">
          <h1>Image Or Video</h1>
          <div class="modal_crd_img">
            <video v-if="$GetExt(value.image) == 'mp4'" :src="$store.state.ASSETS_BASE_URL +
              '/assets/uploaded/' +
              value.image
              " controls></video>
            <img v-else :src="$store.state.ASSETS_BASE_URL +
              '/assets/uploaded/' +
              value.image
              " />
          </div>
        </div>
        <div class="modal_crd">
          <h1>Description</h1>
          <p v-html="value.content"></p>
        </div>
        <div class="split">
          <div class="modal_crd">
            <h1>Visibility</h1>
            <p class="uppper visibility" :class="{ 'unlisted': value.status == 'unlisted' }">{{ value.status }}</p>
          </div>
          <div class="modal_crd">
            <h1>Allow Comments</h1>
            <p class="upper allow" :class="{ 'allowed': value.commentsEnabled }">{{ value.commentsEnabled ? 'YES' : 'NO'
            }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      isModalActive: true
    }
  },
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close")
    }
  }
}
</script>

<style lang="scss" scoped>
.modal_card {
  width: 700px;
  background: white;
  margin: 30px auto;
  border-radius: 5px;

  .modal_title {
    height: 60px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #ddd;
    padding: 0px 20px;
    justify-content: space-between;

    span {
      text-transform: uppercase;
      color: red;
      cursor: pointer;
      font-weight: 700;
    }
  }

  .modal_body {
    padding: 10px 20px 30px;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    row-gap: 25px;

    .modal_crd {
      h1 {
        font-size: 18px;
        margin-bottom: 5px;
      }

      p {
        font-size: 17px;
        color: #00000099;

        &.uppper {
          text-transform: uppercase;
        }

        &.allow {
          color: #F14668;
          font-weight: 800;

          &.allowed {
            color: #48C78E;
          }
        }

        &.visibility {
          display: flex;
          width: fit-content;
          padding: 6px 17px;
          border-radius: 5px;
          background: #48C78E;
          color: white;
          text-transform: uppercase;

          &.unlisted {
            background: #F14668;
          }
        }
      }

      .modal_crd_img {
        height: 400px;
        border-radius: 5px;
        overflow: hidden;

        img,
        video {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    .split {
      display: grid;
      grid-template-columns: 49% 49%;
      justify-content: space-between;
    }
  }
}
</style>